"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DIALOG_GAP: function() {
        return DIALOG_GAP;
    },
    FULLSCREEN_DIALOG_SCROLLBAR_OFFSET: function() {
        return FULLSCREEN_DIALOG_SCROLLBAR_OFFSET;
    },
    MEDIA_QUERY_BREAKPOINT_SELECTOR: function() {
        return MEDIA_QUERY_BREAKPOINT_SELECTOR;
    },
    MEDIA_QUERY_SHORT_SCREEN: function() {
        return MEDIA_QUERY_SHORT_SCREEN;
    },
    SURFACE_BORDER_WIDTH: function() {
        return SURFACE_BORDER_WIDTH;
    },
    SURFACE_PADDING: function() {
        return SURFACE_PADDING;
    }
});
const MEDIA_QUERY_BREAKPOINT_SELECTOR = '@media screen and (max-width: 480px)';
const MEDIA_QUERY_SHORT_SCREEN = '@media screen and (max-height: 359px)';
const SURFACE_PADDING = '24px';
const DIALOG_GAP = '8px';
const SURFACE_BORDER_WIDTH = '1px';
const FULLSCREEN_DIALOG_SCROLLBAR_OFFSET = '4px';
